import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loading } from "@/components/common/Loading";
import { RichTextView } from "@/components/forms/RichTextEditor";

export default function Legal({ docKey = "terms" }) {
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    setDoc(null);
    setError(false);
    api.get(`/legal/${docKey}`)
      .then(({ data }) => { if (active) setDoc(data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [docKey]);

  if (error) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8" data-testid={`legal-${docKey}`}>
        <p className="text-muted-foreground">We couldn't load this page. Please try again.</p>
      </div>
    );
  }
  if (!doc) return <Loading />;

  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8" data-testid={`legal-${docKey}`}>
      <h1 className="text-4xl font-[680] tracking-[-0.02em] text-foreground">{doc.title}</h1>
      {doc.last_updated && (
        <p className="mt-3 text-sm text-muted-foreground" data-testid="legal-last-updated">Last updated {doc.last_updated}</p>
      )}
      <div
        className="mt-8 max-w-none leading-7 [&_a]:text-primary [&_a:hover]:underline [&_h2]:mt-10 [&_h2]:text-lg [&_h2]:font-[640] [&_h2]:text-foreground [&_h3]:mt-6 [&_h3]:font-[600] [&_h3]:text-foreground [&_li]:mt-1 [&_li]:text-muted-foreground [&_ol]:mt-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_p]:mt-3 [&_p]:text-muted-foreground [&_strong]:text-foreground [&_ul]:mt-2 [&_ul]:list-disc [&_ul]:pl-6"
        data-testid="legal-body"
        dangerouslySetInnerHTML={{ __html: doc.body_html || "" }}
      />
    </div>
  );
}
